import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type ecoRestorationDashBoardTable = {
  topHeader: string[];
  header: string[];
  data: any;
  rows?: any;
};

export function EcoRestoartionDashBoardTable({
  data,
  header,
  topHeader,
}: ecoRestorationDashBoardTable) {
  const styles = getStyles(defaultStyles);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {topHeader.map((item, index) => (
              <TableCell
                align="center"
                {...styles("cell")}
                key={index}
                colSpan={2}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {header.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => {
            return (
              <TableRow>
                <TableCell align="center" {...styles("cell")}>
                  {row.sno}
                </TableCell>
                <TableCell
                  align="center"
                  {...styles("cell", { minWidth: "100px", padding: "5px" })}
                >
                  {row.state}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberRegistered}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaRegistered}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberNodalVerificationPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaNodalVerificationPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberVerificationPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaVerificationPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberNodalUnderQuery}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaNodalUnderQuery}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberUnderQuery}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaUnderQuery}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberApproved}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaApproved}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberOldApproved}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaOldApproved}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberRejected}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaRejected}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberWithdrawn}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaWithdrawn}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
